import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useState } from 'react';
import './test.scss';

const initialDataSingle = {
    Id: 1,
    Title: "Column 1",
    Tickets: [
        {
            Id: 1,
            Heading: "Ticket 1",
            Body: "Ticket 1 body"
        },
        {
            Id: 2,
            Heading: "Ticket 2",
            Body: "Ticket 2 body"
        },
        {
            Id: 3,
            Heading: "Ticket 3",
            Body: "Ticket 3 body"
        }
    ]
}

const initialDataMulti = [
    {
        Id: 1,
        Title: "Column 1",
        Tickets: [
            {
                Id: 1,
                Heading: "Ticket 1",
                Body: "Ticket 1 body"
            },
            {
                Id: 2,
                Heading: "Ticket 2",
                Body: "Ticket 2 body"
            },
            {
                Id: 3,
                Heading: "Ticket 3",
                Body: "Ticket 3 body"
            }
        ]
    },
    {
        Id: 2,
        Title: "Column 2",
        Tickets: [
            {
                Id: 4,
                Heading: "Ticket 4",
                Body: "Ticket 4 body"
            },
            {
                Id: 5,
                Heading: "Ticket 5",
                Body: "Ticket 5 body"
            },
            {
                Id: 6,
                Heading: "Ticket 6",
                Body: "Ticket 6 body"
            }
        ]
    },
    {
        Id: 3,
        Title: "Column 3",
        Tickets: [
            {
                Id: 7,
                Heading: "Ticket 7",
                Body: "Ticket 7 body"
            },
            {
                Id: 8,
                Heading: "Ticket 8",
                Body: "Ticket 8 body"
            },
            {
                Id: 9,
                Heading: "Ticket 9",
                Body: "Ticket 9 body"
            }
        ]
    }
]

function Board() {
    const [dataSingle, setDataSingle] = useState(initialDataSingle);
    const [dataMulti, setDataMulti] = useState(initialDataMulti);

    function onDragEndSingle(result: any) {
        const { source, destination } = result;

        if (!destination) return;

        const copiedData = {...dataSingle};
        const [removed] = copiedData.Tickets.splice(source.index, 1);
        copiedData.Tickets.splice(destination.index, 0, removed);
        setDataSingle(copiedData);
    }

    function onDragEndMulti(result: any) {
        const { source, destination } = result;

        if (!destination) return;
        if (source.droppableId === destination.droppableId && source.index === destination.index) return;

        if (source.droppableId === destination.droppableId) {
            const copiedData = [...dataMulti];
            const tickets = copiedData[parseInt(source.droppableId)].Tickets;
            const [removed] = tickets.splice(source.index, 1);
            tickets.splice(destination.index, 0, removed);
            setDataMulti(copiedData);
        } else {
            const copiedData = [...dataMulti];
            const fromTicket = copiedData[parseInt(source.droppableId)].Tickets;
            const toTicket = copiedData[parseInt(destination.droppableId)].Tickets;
            const [removed] = fromTicket.splice(source.index, 1);
            toTicket.splice(destination.index, 0, removed);
            setDataMulti(copiedData);
        }
    }

    return (
        <div id="test">
            <h2>Single List</h2>
            <DragDropContext onDragEnd={onDragEndSingle}>
                <div className="column-container">
                    <div className="column">
                        <p className="column-title">Column 1</p>
                        <Droppable droppableId={"0"}>
                            {(provided, snapshot) => (
                                <div className="ticket-container" ref={provided.innerRef} {...provided.droppableProps}>
                                    {dataSingle.Tickets.map((ticket, i) => (
                                        <Draggable draggableId={ticket.Id.toString()} index={ticket.Id} key={ticket.Id.toString()}>
                                            {(provided, snapshot) => (
                                                <div className="ticket-wrapper" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                    <div className={`ticket ${snapshot.isDragging ? 'dragging': ''}`}>
                                                        <p className="heading">{ticket.Heading}</p>
                                                        <p className="body">{ticket.Body}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </div>
                </div>
            </DragDropContext>

            <h2>Multi List</h2>
            <DragDropContext onDragEnd={onDragEndMulti}>
                <div className="column-container">
                    {dataMulti.map((column, index) => (
                        <div className="column" key={index}>
                            <p className="column-title">{column.Title}</p>
                            <Droppable droppableId={index.toString()}>
                                {(provided, snapshot) => (
                                    <div className="ticket-container" ref={provided.innerRef} {...provided.droppableProps}>
                                        {column.Tickets.map((ticket, i) => (
                                            <Draggable draggableId={ticket.Id.toString()} index={ticket.Id} key={ticket.Id.toString()}>
                                                {(provided, snapshot) => (
                                                    <div className="ticket-wrapper" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <div className={`ticket ${snapshot.isDragging ? 'dragging': ''}`}>
                                                            <p className="heading">{ticket.Heading}</p>
                                                            <p className="body">{ticket.Body}</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </div>
                    ))}
                </div>
            </DragDropContext>
        </div>
    )
}

export default Board;